import React, { useState, useEffect } from "react"
import MatSelectButtons from "./shared/MatSelectButtons";
import DOMPurify from 'dompurify'

const Section2 = ({products, select, setSelect, setStep, step}) =>{

  // const [prodImage, setProdImage] = useState('');
  const [prodDescr, setProdDescr] = useState('');

  var submaterial = -1;
  var roll_length = -1;
  var submaterialList = products[select.material].properties.submaterial;

  function onButtonClick(){
    let elem = document.querySelector('.matselect input:checked')
    let selectedSubmaterial = -1
    let dataset

    if (elem !== null) selectedSubmaterial = parseInt(elem.value)

    if (selectedSubmaterial >= 0){
      dataset = products[select.material].properties.submaterial[selectedSubmaterial]
      roll_length = parseInt(dataset.roll_length)
      let varName = products[select.material].properties.submaterial[selectedSubmaterial].name
      
      if (isNaN(roll_length)) {roll_length = -1;}
      let newSelect = select;
      newSelect.submaterial = selectedSubmaterial
      newSelect.cut = dataset.cut
      newSelect.roll = dataset.roll
      newSelect.roll_length = roll_length
      newSelect.options[`${varName}`] = parseFloat(dataset.coef) 
      setSelect(newSelect)
      setStep(3);
    } else {
      alert(window.lang['s2']['alert_select_mat'])
      return;
    }
  }

  function updateSubmat(){

    let elem = document.querySelector('.matselect input:checked')
    let selectedSubmaterial = -1
    let dataset

    if (elem !== null) selectedSubmaterial = parseInt(elem.value)

    if (selectedSubmaterial >= 0){
      submaterial = parseInt(elem.value);
      dataset = products[select.material].properties.submaterial[submaterial];
    } else {
      return;
    }

    /* update description */
    if (select.submaterial !== '-1'){
      setProdDescr(dataset.about);
    } else {
      setProdDescr(window.lang['s2']['alert_select_mat']);
    }

  }

  useEffect(() => {
    updateSubmat();
  });

  function Material(item, index){
    return(
      <>
        <input key={index} type="radio" name="matselect" id={'submat-'+index} value={index} onChange={updateSubmat} /> 
        <label className="matselect-option" htmlFor={'submat-'+index} style={{backgroundImage : 'url('+item.image+')'}}>
          <span>{item.name}</span>
        </label>
      </>
    )
  }

  function goBack(){
    setSelect({ // '-1' === undefined
        material: -1, 
        submaterial: -1, 
        cut: false,
        cut_flag: false,
        roll: false,
        cutStyle: undefined,
        roll_length: -1,
        length: 0,
        height: 0, 
        indents: 0.5,
        logo: 'BirkisLogo',
        amount: 0,
        basicPrice: {
            priceForAmout: 0
        },
        options: {
            by_amount: 1,
            by_length: 1,
            by_width: 1,
            by_color_count: 1
        },
        finalPrice: {},
        colors:{
            main:'',
            other:''
        },
        calculatedPrice: -1,
        optionsNames:[],
        created: 0
    })
    setStep(1)
}

  return(
    <>
      <div className="section_header">
        <h1>{window.lang['s2']['title']}</h1>
        <div className="step-btns">
          <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s2']['btn_prev']}</span></button>
          <button className="btn btn-next" onClick={() => onButtonClick()} ><span>{window.lang['s2']['btn_next']}</span></button>
        </div>
      </div>
      <p>{window.lang['s2']['note']}</p>
      <div className={"matselect submat-count-"+submaterialList.length}>
        {submaterialList.map((item, index) => Material(item,index) )}
      </div>

      <article className="prod-descr" dangerouslySetInnerHTML={{__html : DOMPurify.sanitize(prodDescr)}} />
      <div className="step-btns">
          <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s2']['btn_prev']}</span></button>
          <button className="btn btn-next" onClick={() => onButtonClick()} ><span>{window.lang['s2']['btn_next']}</span></button>
      </div>

      <MatSelectButtons step={2}/>

    </>
  )
}

export default Section2;

/*
    // updateSubmat ->
    if (elem !== null && dataset.image !== 'false'){
      setProdImage(dataset.image);
    }else{
      setProdImage(document.location.origin+"/wp-content/themes/experon-ebusiness-child/images/not-pictured.png") // image plceholder path
    }
    // <-

      <select id="submaterial" onChange={updateSubmat}>
        {submaterialList.map((item, index) => {
          return(<option key={index} value={index} selected={index===0 ? "selected" : false}>{item.name}</option>)
        })}
      </select>

      <div className="img-with-descr">
        <img className="prod-img" alt="material example" src={prodImage} />
        <article className="prod-descr">{prodDescr}</article>
      </div>

*/